module.exports = __webpack_public_path__ + "resources/img/main03_jp.50fb0c348e06d3a470060b1adb4f25a0.jpg";